import { render } from "./SlackMenu.vue?vue&type=template&id=f90886b2"
import script from "./SlackMenu.vue?vue&type=script&lang=js"
export * from "./SlackMenu.vue?vue&type=script&lang=js"

import "./SlackMenu.vue?vue&type=style&index=0&id=f90886b2&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__